import React from "react";

export const Eyebrow = ({ children, dark = false }) => (
  <div
    className={`mb-4 flex items-center gap-2 font-spaceMono text-[10px] md:text-[11px] uppercase tracking-[8%] ${dark ? "text-[#5C5C5C]" : "text-[#5C5C5C]"}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-[#5C5C5C99]" />
    {children}
  </div>
);

export const Section = ({ children, className = "", id }) => (
  <section
    id={id}
    className={`px-5 py-20 sm:px-8 lg:px-12 lg:py-28 ${className}`}
  >
    <div className="mx-auto max-w-[1320px]">{children}</div>
  </section>
);

export const Progress = ({ label, value, color = "bg-[#f6ada1]" }) => (
  <div className="space-y-1.5">
    <div className="flex justify-between text-[11px] md:text=[12px] font-helvena font-medium text-[#15110B]">
      <span>{label}</span>
      <span>{value}%</span>
    </div>
    <div className="h-[8px] overflow-hidden rounded-full bg-neutral-200">
      <div
        className={`h-full rounded-full ${color}`}
        style={{ width: `${value}%` }}
      />
    </div>
  </div>
);

export const IMAGE_CLASSES = "h-full w-full object-cover";
